import { useEffect } from 'react';

import { Button, ErrorMessage, PasswordField, TextField } from '@ciam/ui';
import { useTranslation } from '@ciam/i18n';
import { FormInputController } from '@ciam/form-kit';
import { AuthForm, AuthTitleSection, pageRedirects, useLoginInfoStore } from '@features/shared';
import {
  AdUserLoginButton,
  CaptchaController,
  ForgotPasswordLink,
  useAdLogin,
  useLoginForm,
  useMfaLogin,
} from '@features/login';
import { useGigyaStore } from '@ciam/gigya-api';
import { useSearchParams } from 'react-router-dom';

const channelsToHideButton = ['gmapad', 'gmapvd', 'mps'];

export const LoginPage = () => {
  const { t } = useTranslation(['login', 'schemas']);
  const { clearLoginInfo } = useLoginInfoStore();
  const [searchParams] = useSearchParams();
  const channel = searchParams.get('channel') ?? 'btp';

  const {
    control,
    onSubmit,
    formState: { errors, isValid },
  } = useLoginForm();

  const addOnGigyaServiceReady = useGigyaStore((state) => state.addOnGigyaServiceReady);
  useEffect(() => {
    addOnGigyaServiceReady({
      page: 'login',
      onLoginFn: async () => {
        await clearLoginInfo();
        await pageRedirects.proxyPage();
      },
    });
  }, [addOnGigyaServiceReady, clearLoginInfo]);

  // AD 로그인 관련 Action
  useAdLogin();
  // MFA 로그인 관련 Action
  useMfaLogin();

  const rootError = errors.root?.message;

  return (
    <>
      <AuthTitleSection title={t('title-section.title')} description={t('title-section.description')} />
      <AuthForm onSubmit={onSubmit}>
        <FormInputController
          name="loginId"
          component={TextField}
          label={t('form.fields.login-id.label')}
          placeholder={t('form.fields.login-id.placeholder')}
          control={control}
          errors={errors}
        />
        <FormInputController
          name="password"
          component={PasswordField}
          label={t('form.fields.password.label')}
          placeholder={t('form.fields.password.placeholder')}
          control={control}
          errors={errors}
        />
        <ForgotPasswordLink />
        <CaptchaController name="captchaToken" control={control} />
        <ErrorMessage message={rootError} />
        <Button
          type="submit"
          size="m"
          buttonTheme={isValid ? 'blue' : 'white'}
          disabled={!isValid}
          aria-label={t('form.fields.button.sign-in')}
        >
          {t('form.fields.button.sign-in')}
        </Button>
        {!channelsToHideButton.includes(channel) && <AdUserLoginButton />}
      </AuthForm>
    </>
  );
};
